import React, { useEffect, useState } from 'react';
import Select from "react-select";
import "../pages/recruitment/RecruitmentCardKam.css";

const SelectOptionTwo = ({ value, data, placeholder, handleChange, required }) => {
    const [options, setOptions] = useState([]);
    const [error, setError] = useState("");

    useEffect(() => {
        const arr = data.map(item => ({ value: item.id, label: item.name }));
        setOptions(arr);
    }, [data]);

    const selectedValue = options.find(o => o.value === value) || null;

    const handleValidation = (selectedOption) => {
        if (!selectedOption) {
            setError("This field is required");
        } else {
            setError("");
        }
        handleChange(selectedOption);
    };

    return (
      <div className="select-container">
          <Select
            className="input-cont-2"
            placeholder={placeholder}
            options={options}
            isClearable={true}
            noOptionsMessage={() => "Not found"}
            onChange={handleChange}
            value={selectedValue}
          />
          {error && <span className="error-message">{error}</span>}
      </div>
    );
};

export default SelectOptionTwo;
